import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=a4b348b4&scoped=true&"
import script from "./FlagIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FlagIcon.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=a4b348b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b348b4",
  null
  
)

export default component.exports